import type {
  PartnerAdminTopBanner,
  PutApiV1ThreeLetterCodePartnerAdminsTopBannersIdBody,
} from '@fukuri-admins/apis/client/gen/model';
import { fileToUrlByBase64 } from '@fukuri-admins/utils/common';
import { EditTopBannerFormFieldValues } from '../schema';

type GenerateRequestArgs = {
  /** フォームの入力値 */
  formValues: EditTopBannerFormFieldValues;
  /** 既存のトップバナーデータ（sortOrder維持用） */
  existingTopBanner: PartnerAdminTopBanner;
};

type IGenerateRequest = (
  args: GenerateRequestArgs
) => Promise<PutApiV1ThreeLetterCodePartnerAdminsTopBannersIdBody>;

/**
 * フォームの値からAPIリクエストボディを生成する
 *
 * image:
 * - File → Base64に変換して送信
 * - undefined → 既存画像維持（imageフィールドを含めない）
 */
export const generateRequest: IGenerateRequest = async ({ formValues, existingTopBanner }) => {
  const { title, transitionUrl, status, image, groupId, restrictedToApp, targetUserType } =
    formValues;

  return {
    top_banner: {
      title,
      transition_url: transitionUrl,
      status: Number(status),
      sort_order: existingTopBanner.sort_order,
      group_id: groupId ? Number(groupId) : null,
      restricted_to_app: restrictedToApp === 'true',
      target_user_type: targetUserType,
      ...(image && { image: await fileToUrlByBase64(image) }),
    },
  };
};
